import * as React from "react";
import { observer } from "mobx-react-lite";
import { Box, skinVars, Stack, Text2, Text8, ButtonLink } from "@telefonica/mistica";
import { formatAmount, formatCallCenterPhone } from "../../utils/formatters";

interface IProps {
	title: string;
	value: number | string;
	helperText?: string;
}

export const SimulationValueCard: React.FC<IProps> = observer((props) => {
	const { helperText, value, title } = props;

	const handlePress = (phoneNumber: string): void => {
		window.location.href = `tel:${phoneNumber}`;
	};

	return (
		<Box className="card-background-alternative text-align-center" paddingX={32} paddingY={16}>
			<Stack space={4}>
				<Text2 medium>{title}</Text2>
				{typeof value === "string" ? (
					<ButtonLink onPress={() => handlePress(value)} bleedLeft bleedRight>
						<Text8 color={skinVars.colors.brand}>{formatCallCenterPhone(value)}</Text8>
					</ButtonLink>
				) : (
					<Text8 color={skinVars.colors.brand}>{formatAmount(value)}</Text8>
				)}
				{helperText && (
					<Text2 regular color={skinVars.colors.textSecondary}>
						{helperText}
					</Text2>
				)}
			</Stack>
		</Box>
	);
});
